/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { FilesRequestBuilderRequestsMetadata, type FilesRequestBuilder } from './files/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /search
 */
export interface SearchRequestBuilder extends BaseRequestBuilder<SearchRequestBuilder> {
    /**
     * The files property
     */
    get files(): FilesRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const SearchRequestBuilderUriTemplate = "{+baseurl}/search";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SearchRequestBuilderNavigationMetadata: Record<Exclude<keyof SearchRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    files: {
        requestsMetadata: FilesRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
